// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../iot-devtool/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../iot-devtool/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clear-model {\n    background: rgba(0,0,0,0) !important;\n}", "",{"version":3,"sources":["webpack://./src/apps/log/component/index.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC","sourcesContent":[".clear-model {\n    background: rgba(0,0,0,0) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
